import GoogleSSOComponent from './google-sso-button-component'
import GoogleSSOService from './google-sso-button-service'
import AppConfig from '../../app-config.json'

/***
 * The login button that launches a Google SSO modal and authenticates the user with the server.
 */
const googleSsoButton = angular
    .module('FacilityData.GoogleSSO', [])
    .component('googleSsoButton', GoogleSSOComponent)
    .service('GoogleSSOService', GoogleSSOService)
    .config(($stateProvider) => {
        'ngInject';
        $stateProvider.state('app.ssoLoginRedirect', {
            url: '/sso/callback/',
            resolve: {
                authSSO($http, $state, Idle, GoogleSSOService) {
                    const regexRes = window.name.match(/(?:id_token)\=([\S\s]*?)\&/);
                    if (!regexRes) {
                        return;
                    }
                    window.name = '';
                    const id_token = regexRes[1];
                    const data = { id_token };
                    $http.post(`${AppConfig.apiUrl}/auth/`, data)
                        .then(r => {
                            // Begin watching for the user to idle, now that they are logged in.
                            Idle.watch();
                            // Reload the current state to update it for the user's permissions.
                            $state.go('app.home', {}, { reload: true });
                        })
                        .catch(err => {
                            console.log('err', err);
                            GoogleSSOService.loginErrorMessage = err.data.error;
                            $state.go('app.home', {}, { reload: true });
                        });
                }
            },
        });
    })
    .name;

export default googleSsoButton;


// WEBPACK FOOTER //
// ./app/components/google-sso-button/google-sso-button.js